import * as ProductCategory from '@/services/rest-api/lib/product/product-category'

const defaultFieldOpts = {
  editable: true,
  isSortable: true,
}

const productTypeFields = [
  {
    ...defaultFieldOpts,
    name: 'name',
    label: 'setting.list.product.field.productType',
    placeholder: 'setting.list.product.field.productType',
    key: 'name',
    type: 'text',
    validation: 'required',
    thAttr: {
      style: 'min-width:230px;'
    }
  },
  {
    ...defaultFieldOpts,
    name: 'product_category_id',
    label: 'setting.list.product.field.productCategory',
    placeholder: 'setting.list.product.field.productCategory',
    key: 'product_category.name',
    type: 'select-resourceful',
    validation: 'required',
    optionsGetter: ProductCategory.get,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj?.product_category ?? obj,
    trackBy: 'id',
    // custom value fn to be set on the input (initial value)
    customValueFn: (item) => item?.product_category?.id,
    tabIndex: 0,
    thAttr: {
      style: 'min-width:180px;'
    }
  },
  {
    editable: false,
    isSortable: false,
    key: 'product_category.box_types',
    label: 'setting.list.product.field.boxType',
    customColumn: true,
    thAttr: {
      style: 'min-width:350px;'
    }
  },
  {
    editable: false,
    isSortable: true,
    key: 'product_category.min_temperature',
    sortKey: 'min_temperature',
    label: 'setting.list.product.field.minTemperature',
    thAttr: {
      style: 'min-width:200px;'
    }
  },
  {
    editable: false,
    isSortable: true,
    key: 'product_category.max_temperature',
    sortKey: 'max_temperature',
    label: 'setting.list.product.field.maxTemperature',
    thAttr: {
      style: 'min-width:200px;'
    }
  },
]

export default productTypeFields
